import { Fragment } from 'react/jsx-runtime';
import { TypeOfLeasing } from '../../../types';
import useSettingsStore from '../../components/fleet-calculator/store/settings-store';
import { businessExcerpt, excerpt, financialExcerpt } from './copy';

const CarExcerpt = () => {
  const { typeOfLeasing } = useSettingsStore();

  return (
    <div className="grid gap-2 mb-4">
      {excerpt.map((item) => {
        return (
          <Fragment key={item.heading}>
            {item.heading ? (
              <h2 className="text-xl font-semibold">{item.heading}</h2>
            ) : null}
            {item.paragraph ? <p className="pb-2">{item.paragraph}</p> : null}
          </Fragment>
        );
      })}
      {typeOfLeasing === TypeOfLeasing.BUSINESS ? (
        <h2 className="text-xl font-semibold">{businessExcerpt.heading}</h2>
      ) : (
        <h2 className="text-xl font-semibold">{financialExcerpt.heading}</h2>
      )}
    </div>
  );
};

export default CarExcerpt;
